import { Project } from '../../types'

export type Summary = {
  invoiceable: SummaryInvoiceable
  totals: SummaryTotals
  paid: SummaryTotals
  outstanding: SummaryTotals
  overdue: SummaryTotals
}
export type SummaryInvoiceable = {
  receiptCount: number
  amount: number
}
export type SummaryTotals = {
  count: number
  totalPrice: number
}

export type StateInfo = {
  concept: number
  validation: number
  definitive: number
  sent: number
  cancelled: number
  overdue: number
  paid: number
}


export const InvoicingDashboardDeviationType = {
  incompleteDrafts: 0,
  waitingForReview: 1,
  overdueInvoices: 2
} as const

export type Deviation = {
  type: number
  severity: number
  count: number
}

export type Receivables = {
  outstandingTotalPrice: number
  overdue: ReceivablesOverdue
}
export type ReceivablesOverdue = {
  totalPrice: number
  count: number
  aging: OverdueAging[]
}
export type OverdueAging = {
  rangeFromDays: number
  rangeToDays: number
  count: number
  totalPrice: number
}

export type InvoicesListItem = {
  invoice: Invoice
  customer: Customer
  project: Project
  status: InvoiceStatus
}
export type Invoice = {
  id: number
  number: string
  date: string
  totalPrice: number
  outstanding: number
  dueDate: string
  status: InvoiceStatus
}
export type InvoiceStatus = {
  id: number
  description: string
}

export type Validation = {
   waitingForApproval: number
   rejected: number
}

export type Customer = {
  id: number
  name: string
}

export type InvoicingDashboardData = {
  summary: Summary
  stateInfo: StateInfo
  deviations: Deviation[]
  list: InvoicesListItem[]
  outstanding: Receivables
}
